<template>
  <div class="pre-consultation-card">
    <div class="pre-consultation-card__header">
      <div class="pre-consultation-card__title-wrap">
        <img :src="imgArr.a9" class="pre-consultation-card__logo" />
        <span class="pre-consultation-card__title">诊前知己</span>
        <span class="pre-consultation-card__desc">本内容由AI生成，仅供参考</span>
      </div>
      <i class="el-icon-close pre-consultation-card__close" @click="$emit('close')"></i>
    </div>

    <div class="pre-consultation-card__body" v-if="doctorPatientSummary">
      <section class="pre-consultation-card__panel patient-panel">
        <div class="patient-panel__base">
          <div class="patient-panel__name-wrap">
            <span class="patient-panel__name">{{ doctorPatientSummary.baseInfo.patientName }}</span>
            <span class="patient-panel__meta">{{ doctorPatientSummary.baseInfo.sex }} / {{
              doctorPatientSummary.baseInfo.age }}岁</span>
          </div>
          <div class="patient-panel__tags"
            v-if="doctorPatientSummary.baseInfo.allergyHistory && doctorPatientSummary.baseInfo.allergyHistory.length > 0">
            <span class="patient-panel__tag patient-panel__tag--danger"
              v-for="value in doctorPatientSummary.baseInfo.allergyHistory">{{ value }}</span>
            <!-- <span class="patient-panel__tag patient-panel__tag--warning">高血压</span>
            <span class="patient-panel__tag patient-panel__tag--success">阳虚体质</span> -->
          </div>
        </div>
        <div class="patient-panel__stats">
          <div class="patient-panel__stat">
            <img :src="imgArr.a14" class="patient-panel__stat-icon" />
            <span>累计就诊</span>
            <strong>{{ doctorPatientSummary.baseInfo.visitCount }}次</strong>
          </div>
          <div class="patient-panel__divider"></div>
          <div class="patient-panel__stat">
            <img :src="imgArr.a17" class="patient-panel__stat-icon" />
            <span>就诊频率</span>
            <strong>{{ doctorPatientSummary.baseInfo.revisitFrequency }}</strong>
          </div>
        </div>
      </section>

      <section class="pre-consultation-card__panel visit-panel">
        <h3 class="pre-consultation-card__section-title">近期就诊记录</h3>
        <div class="visit-panel__list">
          <div v-if="doctorPatientSummary.caseItems && doctorPatientSummary.caseItems.length > 0">
            <div v-for="(record, index) in doctorPatientSummary.caseItems" :key="index" class="visit-panel__item"
              :class="{ 'is-active': activeVisit == record.visitDate }">
              <div class="visit-panel__summary" @click="toggleVisit(record.visitDate)">
                <span class="visit-panel__date">{{ record.visitDate }}</span>
                <span v-if="record.latest" class="visit-panel__latest">（最近一次）</span>
                <span class="visit-panel__diagnosis">{{ record.diagnosis }}</span>
                <i :class="activeVisit == record.visitDate ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
              </div>
              <div v-if="activeVisit == record.visitDate" class="visit-panel__detail">
                <div class="visit-panel__detail-row">
                  <span>主诉</span>
                  <strong>{{ record.chiefComplaint }}</strong>
                </div>
                <div class="visit-panel__detail-row">
                  <span>治疗</span>
                  <strong>{{ record.treatmentPlan }}</strong>
                </div>
                <div class="visit-panel__detail-row" v-if="record.feedback">
                  <span>疗效</span>
                  <strong>{{ record.feedback }}</strong>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="visit-panel__empty">
            <img :src="imgArr.a18" class="visit-panel__empty-icon" />
            <span class="visit-panel__empty-text">暂无就诊记录</span>
          </div>
        </div>

        <div class="finding-card"
          v-if="doctorPatientSummary.supplementFindings && doctorPatientSummary.supplementFindings.length > 0">
          <div class="finding-card__content">
            <div class="finding-card__title">
              <img :src="imgArr.a12" class="finding-card__title-icon" />
              <span>补充发现</span>
            </div>
            <ul class="finding-card__list">
              <li v-for="(item, index) in doctorPatientSummary.supplementFindings" :key="index">{{ item.content }}</li>
            </ul>
          </div>
          <img :src="imgArr.a16" class="finding-card__bg" />
        </div>

        <div class="evidence-card"
          v-if="doctorPatientSummary.supplementSources && doctorPatientSummary.supplementSources.length > 0">
          <div class="evidence-card__header" @click="toggleEvidence">
            <span>查看依据</span>
            <i :class="evidenceOpen ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </div>
          <div v-if="evidenceOpen" class="evidence-card__content">
            <div v-for="(item, index) in doctorPatientSummary.supplementSources" :key="index">【{{ item.sourceTag }}】{{
              item.sourceText.join('、') }}</div>
          </div>
        </div>
      </section>

      <section class="pre-consultation-card__panel advice-panel"
        v-if="doctorPatientSummary.aiSuggestion && doctorPatientSummary.aiSuggestion.length > 0">
        <div class="advice-panel__header" @click="toggleAdvice">
          <div class="advice-panel__title-wrap">
            <img :src="imgArr.a13" class="advice-panel__icon" />
            <span class="advice-panel__title">接诊建议</span>
            <span class="advice-panel__desc">智能提炼本次接诊关注点</span>
          </div>
          <i :class="adviceOpen ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        </div>
        <div v-if="adviceOpen" class="advice-panel__content">{{ doctorPatientSummary.aiSuggestion.join('，') || '' }}
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { imgArr } from '@/assets/images/img'
export default {
  name: 'PreConsultationHelper',
  props: {
    orderId: {
      type: String,
      default: ''
    },
    doctorId: {
      type: String,
      default: ''
    },
    doctorPatientSummary: {
      type: Object,
      default: () => { }
    }
  },
  watch: {
    doctorPatientSummary: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.activeVisit = newVal.caseItems && newVal.caseItems.length > 0 ? newVal.caseItems[0].visitDate : ''
        }
      },
    }
  },
  data() {
    return {
      imgArr: imgArr,
      activeVisit: '',
      evidenceOpen: false,
      adviceOpen: false,
    }
  },
  methods: {
    toggleVisit(visitDate) {
      this.activeVisit = this.activeVisit == visitDate ? '' : visitDate
      window.$trackTool.track({ v: '1', b: 'his_000012', t: 'his_0003' }, { updateTime: new Date().Format('yyyy-MM-dd hh:mm:ss'), orderId: this.orderId, doctorId: this.doctorId })
    },
    toggleEvidence() {
      this.evidenceOpen = !this.evidenceOpen
      window.$trackTool.track({ v: '1', b: 'his_000013', t: 'his_0003' }, { updateTime: new Date().Format('yyyy-MM-dd hh:mm:ss'), orderId: this.orderId, doctorId: this.doctorId })
    },
    toggleAdvice() {
      this.adviceOpen = !this.adviceOpen
      window.$trackTool.track({ v: '1', b: 'his_000014', t: 'his_0003' }, { updateTime: new Date().Format('yyyy-MM-dd hh:mm:ss'), orderId: this.orderId, doctorId: this.doctorId })
    }
  }
}
</script>

<style lang="less" scoped>
.pre-consultation-card {
  width: 444px;
  // min-height: 600px;
  max-height: 675px;
  border-radius: 10px;
  overflow: auto;
  background: linear-gradient(180deg, #cfe7ff 0%, #86c7ff 100%);
  box-shadow: 0 8px 24px rgba(62, 139, 220, 0.28);
  font-family: PingFang SC, Microsoft YaHei, Arial, sans-serif;
}

.pre-consultation-card__header {
  height: 50px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  color: #1f2329;
}

.pre-consultation-card__title-wrap {
  display: flex;
  align-items: center;
  min-width: 0;
}

.pre-consultation-card__logo {
  width: 22px;
  height: 22px;
  margin-right: 8px;
  flex: 0 0 auto;
}

.pre-consultation-card__title {
  font-size: 17px;
  font-weight: 600;
  color: #1f2329;
  white-space: nowrap;
}

.pre-consultation-card__desc {
  margin-left: 8px;
  font-size: 12px;
  color: #748096;
  white-space: nowrap;
}

.pre-consultation-card__close {
  font-size: 18px;
  color: #637894;
  cursor: pointer;
}

.pre-consultation-card__body {
  padding: 0 12px 12px;
}

.pre-consultation-card__panel {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(114, 157, 208, 0.1);
}

.patient-panel {
  overflow: hidden;
}

.patient-panel__base {
  min-height: 38px;
  padding: 0 14px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  border-bottom: 1px solid #edf2f8;
  box-sizing: border-box;
}

.patient-panel__name-wrap {
  // display: flex;
  // align-items: center;
  // flex-wrap: wrap;
  flex-shrink: 0;

}

.patient-panel__name {
  font-size: 18px;
  font-weight: 700;
  color: #1f2329;
}

.patient-panel__meta {
  margin-left: 8px;
  font-size: 13px;
  color: #667182;
  flex-shrink: 0;
}

.patient-panel__tags {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.patient-panel__tag {
  height: 26px;
  padding: 0 10px;
  display: inline-flex;
  align-items: center;
  border-radius: 3px;
  font-size: 13px;
  font-weight: 600;
}

.patient-panel__tag--danger {
  color: #e64f4f;
  background: #fff1f1;
}

.patient-panel__tag--warning {
  color: #9a7227;
  background: #fff5d8;
}

.patient-panel__tag--success {
  color: #1e9e5a;
  background: #e7f8ee;
}

.patient-panel__stats {
  height: 34px;
  display: flex;
  align-items: center;
  padding: 0 14px;
  box-sizing: border-box;
}

.patient-panel__stat {
  display: flex;
  align-items: center;
  min-width: 0;
  font-size: 13px;
  color: #667182;
}

.patient-panel__stat strong {
  margin-left: 6px;
  font-size: 14px;
  color: #1f2329;
}

.patient-panel__stat-icon {
  width: 16px;
  height: 16px;
  margin-right: 5px;
}

.patient-panel__divider {
  width: 1px;
  height: 20px;
  margin: 0 22px;
  background: #edf2f8;
}

.visit-panel {
  margin-top: 10px;
  padding: 12px;
  box-sizing: border-box;
}

.pre-consultation-card__section-title {
  margin: 0 0 6px;
  font-size: 15px;
  line-height: 22px;
  color: #1f2329;
}

.visit-panel__list {
}

.visit-panel__empty {
  height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding-top: 50px;
}

.visit-panel__empty-icon {
  width: 80px;
  height: 95px;
}

.visit-panel__empty-text {
  font-weight: 400;
  font-size: 12px;
  color: #A0AAB9;
  margin-top: 16px;
}

.visit-panel__item {
  margin-bottom: 8px;
  border: 1px solid #edf2f8;
  border-radius: 5px;
  background: #fff;
  overflow: hidden;
}

.visit-panel__item:last-child {
  margin-bottom: 0;
}

.visit-panel__item.is-active {
  background: linear-gradient(180deg, #f8fbff 0%, #fff 100%);
}

.visit-panel__summary {
  height: 32px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
  box-sizing: border-box;
}

.visit-panel__date,
.visit-panel__latest {
  font-size: 14px;
  font-weight: 600;
  color: #9099a8;
}

.visit-panel__diagnosis {
  margin-left: 8px;
  flex: 1;
  font-size: 14px;
  font-weight: 600;
  color: #409eff;
}

.visit-panel__summary i {
  font-size: 16px;
  color: #b2bac8;
}

.visit-panel__detail {
  padding: 0 12px 10px;
}

.visit-panel__detail-row {
  display: flex;
  line-height: 24px;
  font-size: 14px;
}

.visit-panel__detail-row span {
  width: 42px;
  color: #8b95a4;
  flex-shrink: 0;
}

.visit-panel__detail-row strong {
  font-weight: 600;
  color: #4b5565;
}

.finding-card {
  position: relative;
  min-height: 116px;
  margin-top: 8px;
  padding: 8px 120px 8px 8px;
  border-radius: 6px;
  background: linear-gradient(135deg, #eafff4 0%, #f3fff8 100%);
  overflow: hidden;
  box-sizing: border-box;
}

.finding-card__content {
  position: relative;
  z-index: 1;
}

.finding-card__title {
  display: flex;
  align-items: center;
  color: #19b66a;
  font-size: 15px;
  font-weight: 700;
}

.finding-card__title-icon {
  width: 18px;
  height: 18px;
  margin-right: 6px;
}

.finding-card__list {
  margin: 8px 0 0;
  padding: 0;
  list-style: none;
}

.finding-card__list li {
  position: relative;
  padding-left: 14px;
  line-height: 24px;
  color: #333b47;
  font-size: 13px;
  font-weight: 600;
}

.finding-card__list li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 10px;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #1cc96b;
}

.finding-card__bg {
  position: absolute;
  right: 14px;
  bottom: 8px;
  width: 92px;
  height: 78px;
  object-fit: contain;
  opacity: 0.88;
}

.evidence-card {
  margin-top: 8px;
  padding: 0 2px;
  color: #748096;
  font-size: 13px;
}

.evidence-card__header {
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.evidence-card__content {
  line-height: 22px;
}

.advice-panel {
  margin-top: 10px;
  overflow: hidden;
  background: linear-gradient(180deg, #f1f1ff 0%, #fff 100%);
}

.advice-panel__header {
  height: 44px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  box-sizing: border-box;
}

.advice-panel__title-wrap {
  display: flex;
  align-items: center;
}

.advice-panel__icon {
  width: 18px;
  height: 18px;
  margin-right: 6px;
}

.advice-panel__title {
  font-size: 15px;
  font-weight: 700;
  color: #2e75ff;
}

.advice-panel__desc {
  margin-left: 8px;
  font-size: 12px;
  color: #9099a8;
}

.advice-panel__content {
  margin: 0 10px 10px;
  padding: 8px 12px;
  border-radius: 3px;
  background: #fff;
  color: #667182;
  font-size: 14px;
  line-height: 22px;
}
</style>

<style lang="less">
.el-popover.pre-consultation-helper-popper {
  padding: 0;
  border: none;
  border-radius: 10px;
  background: transparent;
  box-shadow: none;
}
</style>